const Backbone = require('backbone');
const EstimatedDeliveryInformationModel = require('models/store/client/product/estimated_delivery');
const { ZipChangerView } = require('app/views/store/common/zip_changer');
const QuickShipTemplate = require('app/templates/store/global/pages/products/partials/_quick_ship.dust');
const FreeShippingMessageView = require('app/views/store/pages/products/freeshipping_message');
const productTrackingHelper = require('../../../../../lib/helpers/product_tracking_helper');
const dustjs = require('dustjs');
const dateFns = require('date-fns');
const MAX_CUTOFF_HOUR = 24;
const REFRESH_TIME = 300000; // 5 mins (300000ms)
const REFRESH_MAX_THRESHOLD = 250;
const enums = require('lib/enums');

require('app/templates/store/global/common/zip_changer.dust');

module.exports = Backbone.View.extend({
	events: {
		'click .js-change-zip-button': '_toggleForm'
	},
	initialize() {
		this.container = this.$el.find('.js-quick-ship-container');
		this.initialPostalCode = this.container.data('postalCode') ? this.container.data('postalCode').toString() : '';
		this.zipForm = this.$el.find('.js-change-zip-form');
		this.spinner = this.$el.find('.js-spinner');
		this.customerLocation = window.dataLayer.customerLocation || { highCost: false, zipCode: '' };
		this.currentUniqueId = null;
		window.BCOM.data = window.BCOM.data || {};
		this.estimatedDeliveryModel = new EstimatedDeliveryInformationModel({
			postalCode: this.initialPostalCode,
			productCompositeId: this.model.get('productCompositeId')
		});

		this._fetchEstimatedDelivery(this.initialPostalCode);
		this._setupListeners();
		this.freeShippingMessageView = new FreeShippingMessageView({
			model: this.model
		});
		return this;
	},

	_setupListeners() {
		this.listenTo(Backbone, 'finish:clicked', this._updateUniqueId.bind(this, true));
		this.listenTo(Backbone, 'finish:hover', this._updateUniqueId.bind(this, false));
		this.listenTo(Backbone, 'zipCode:changed', this._handleZipChanged.bind(this));
		this.listenTo(Backbone, 'zipCode:noChange', this._handleZipChanged.bind(this));
		this.listenTo(Backbone, 'zipCode:successLocation', this._trackZipCodeChangeSuccessLocation.bind(this));
	},

	_updateUniqueId(isClickEvent, data) {
		this.currentUniqueId = data.uniqueId;
		if (this.estimatedDeliveryModel.get('estimatedDeliveryInfo')) {
			this.render(this.initialPostalCode);
		}
	},

	_trackZipCodeChangeSuccessLocation() {
		// exclude firing event on initial page load
		if (!window.dataLayer.zipCodeChangeEvent) {
			return false;
		}
		const hasRestrictions = window.dataLayer.restrictions && window.dataLayer.restrictions.length > 0;
		const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo');
		// make data avail for add to cart tracking
		window.BCOM.estimatedDeliveryInfo = estimatedDeliveryInfo;
		let trackingData;

		if (window.dataLayer.page === 'product:display' || window.dataLayer.page === 'product-pla:display') {
			trackingData = productTrackingHelper.setZipChangeTrackingData(
				{
					categoryName: window.dataLayer.rootCategory && window.dataLayer.rootCategory.categoryName,
					freight: window.dataLayer.freight,
					manufacturer: window.dataLayer.manufacturer,
					sale: window.dataLayer.sale || (window.dataLayer.selectedFinish && window.dataLayer.selectedFinish.sale)
				},
				window.dataLayer.selectedFinish,
				window.dataLayer.finishes,
				this.currentUniqueId,
				'zip-change-success',
				estimatedDeliveryInfo
			);
			if (hasRestrictions) {
				trackingData.props.prop47 = '';
			}
		} else {
			trackingData = {
				linkName: 'zip-change-success'
			};
		}
		this._trackLink(trackingData);
	},

	_toggleForm() {
		if (this.zipChangerView) {
			this.zipChangerView.toggleForm();
		}
		this._trackLink(`zip-change-form-toggle`);
	},

	_trackLink(linkData) {
		Backbone.trigger('track:link', linkData);
	},

	getFinish(uniqueId) {
		const finishes = window.dataLayer.finishes;
		return finishes.find((f) => f.uniqueId === uniqueId);
	},

	render(postalCode) {
		this.initialPostalCode = postalCode;
		const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo'),
			currentFinish = estimatedDeliveryInfo && estimatedDeliveryInfo.find((info) => info.productUniqueId === this.currentUniqueId);
		window.BCOM.estimatedDeliveryInfo = estimatedDeliveryInfo;
		if (!currentFinish) {
			return this;
		}
		this.spinner.hide();
		const quickShipInfo = this._getQuickShipInfo(currentFinish, postalCode);
		// Exclude products with price < 49 from the test.
		if (quickShipInfo.quickShip) {
			this._renderTemplate(quickShipInfo, postalCode, true);
			// start timer to update quickship details
			this._startTimer();
		} else {
			this._renderTemplate(quickShipInfo, postalCode, false);
			// remove any existing timers.
			this._stopTimer();
		}
		return this;
	},

	_renderTemplate(quickShipInfo, postalCode, isQuickShip) {
		window.BCOM.data.isQuickShip = Boolean(isQuickShip);
		dustjs.render(QuickShipTemplate, quickShipInfo, this._handleRenderResponse.bind(this));
		this._renderFinishes(QuickShipTemplate, postalCode);
		this.freeShippingMessageView._toggleShippingMessage(this.customerLocation, isQuickShip);
	},
	_renderFinishes(template, postalCode) {
		if (window.BCOM.device.isMobile) {
			const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo');
			estimatedDeliveryInfo.forEach((deliveryInfo) => {
				const viewModel = this._getQuickShipInfo(deliveryInfo, postalCode);
				viewModel.hideZipChanger = true;
				dustjs.render(template, viewModel, (err, output) => {
					$(`.js-mobile-finishes-estimated-delivery-${deliveryInfo.productUniqueId}`).html(output);
				});
			});
		}
	},

	_getQuickShipInfo(deliveryInfo, postalCode) {
		const shippingCutOff = deliveryInfo.shippingCutOff;
		const estimatedDelivery = deliveryInfo.estimatedDeliveryDate;
		const estimationMethod = deliveryInfo.deliveryEstimateMethod && deliveryInfo.deliveryEstimateMethod.toLowerCase();
		const currentFinish = this.getFinish(deliveryInfo.productUniqueId) || null;
		const currentFinishPrice = currentFinish && currentFinish.price;
		const hasFreeShipping = Boolean(currentFinish && currentFinish.freeShipping);
		const isQuickShip = deliveryInfo.isQuickShip && (currentFinishPrice > enums.FREESHIPPING_THRESHOLDS.PARCEL || hasFreeShipping);
		const abPlaQuickshipFree = window.dataLayer.abPlaQuickshipFree || false;
		const isQuickShipPla = window.dataLayer.isPla || false;
		if (
			!shippingCutOff ||
			!estimatedDelivery ||
			!isQuickShip ||
			estimationMethod === enums.DELIVERY_METHOD.LEAD_TIME_OFFSET.toLowerCase()
		) {
			return {
				deliveryMessage: this._getDeliveryMessage(deliveryInfo, postalCode, estimationMethod),
				postalCode,
				quickShip: false
			};
		}
		let shippingCutOffDate = new Date(shippingCutOff);
		let estimatedDeliveryDate = new Date(estimatedDelivery);
		let diffInMins = dateFns.differenceInMinutes(shippingCutOffDate, new Date());
		// Edge case should not ideally happen.
		if (diffInMins < 0) {
			shippingCutOffDate = dateFns.addDays(shippingCutOffDate, deliveryInfo.lowDays || 0);
			diffInMins = dateFns.differenceInMinutes(shippingCutOffDate, new Date());
			estimatedDeliveryDate = dateFns.addDays(shippingCutOffDate, deliveryInfo.transitDays || 0);
		}
		const deliveryDay = dateFns.isTomorrow(estimatedDeliveryDate) ? 'Tomorrow' : dateFns.format(estimatedDeliveryDate, 'iiii');
		const hrs = Math.floor(diffInMins / 60);
		const mins = diffInMins % 60;
		const cutoffTime = this._getCutOffTime(hrs, mins);
		return {
			deliveryDay,
			cutoffTime,
			transitDays: deliveryInfo.transitDays,
			postalCode,
			hrs,
			quickShip: isQuickShip,
			quickShipVariation: window.dataLayer.quickShipVariation,
			cutoffExceedsThreshold: hrs >= MAX_CUTOFF_HOUR,
			abPlaQuickshipFree,
			isQuickShipPla
		};
	},

	_startTimer() {
		if (this.timeOut) {
			return this;
		}
		let counter = 0;
		this.timeOut = setInterval(() => {
			this._fetchEstimatedDelivery(this.initialPostalCode);
			if (counter > REFRESH_MAX_THRESHOLD) {
				this._stopTimer();
			}
			counter += 1;
		}, REFRESH_TIME);
		return this;
	},

	_stopTimer() {
		if (this.timeOut) {
			clearInterval(this.timeOut);
			this.timeOut = null;
		}
	},

	_getCutOffTime(hrs, mins) {
		let cutOffTime = '';
		// edge case: this can happen on the exact min of shipping cut off.
		if (hrs === 0 && mins === 0) {
			return '1 min';
		}
		if (hrs > 0) {
			cutOffTime += `${hrs}${hrs > 1 ? ' hrs' : ' hr'} `;
		}
		if (mins > 0) {
			cutOffTime += `${mins}${mins > 1 ? ' mins' : ' min'}`;
		}
		return cutOffTime;
	},

	_getDeliveryMessage(finishEstimatedDelivery, currentZipcode, estimationMethod) {
		const defaultMessage = `Delivery date not available for ${currentZipcode}`;
		if (estimationMethod && estimationMethod.toLowerCase() === enums.DELIVERY_METHOD.LEAD_TIME_OFFSET.toLowerCase()) {
			return finishEstimatedDelivery.text || defaultMessage;
		}
		return finishEstimatedDelivery.deliveryEstimate || finishEstimatedDelivery.text || defaultMessage;
	},

	_handleZipChanged(postalCode) {
		if (postalCode && postalCode !== this.estimatedDeliveryModel.get('postalCode')) {
			this._toggleForm();
			this.spinner.show();
			this.estimatedDeliveryModel.set('postalCode', postalCode).fetch({
				success: () => {
					window.dataLayer.isEstimatedDeliveryUpdateComplete = true;
					if (window.dataLayer.isRestrictionsUpdateComplete) {
						this._trackZipCodeChangeSuccessLocation();
					}
					this.render(postalCode);
				},
				error: this._handleFetchError.bind(this)
			});
		} else {
			this._trackLink({ linkName: `zip-change-same-zip-or-fail` });
			this._toggleForm();
		}
	},

	_fetchEstimatedDelivery(postalCode) {
		if (this.estimatedDeliveryModel.isValid()) {
			this.estimatedDeliveryModel.fetch({
				success: this._handleFetchSuccess.bind(this, postalCode),
				error: this._handleFetchError.bind(this)
			});
		} else if (postalCode) {
			this.render(postalCode);
		} else {
			this.spinner.hide();
			this.zipChangerView = new ZipChangerView({
				zip: ''
			});
			this._toggleForm();
		}
	},

	_handleFetchSuccess(postalCode) {
		if (this.currentUniqueId) {
			this.render(postalCode);
		}
	},
	_handleRenderResponse(err, output) {
		if (err) {
			window.clientErrorHandler(err);
		}
		this.$el.html(output);
		this.zipChangerView = new ZipChangerView({
			zip: this.initialPostalCode
		});
	},
	_handleFetchError() {
		this.estimatedDeliveryModel.unset('estimatedDeliveryInfo');
	}
});
